module.exports = "https://i-jinbaozheng-network-website.oss-cn-shanghai.aliyuncs.com//img/about-us-banner-image.a9bfbb55.jpg";